// types
import { i18nSystemCodebooks } from 'models/i18n';
import { ReservedCapacityGuardingCheckResultStatus } from 'views/modules/Dispatcher/RkDashboard/rkDashboardTypes';
import { ReservedCapacityGuardingActionTypeEnum } from 'features/dispatcher/dispatcherReservedCapacityGuardingTypes';
import { ActivityLogEventCode } from 'models/dispatcher';

const skSystemCodebooks: i18nSystemCodebooks = {
  ElectricalPowerUnit: {
    W: {
      title: 'W'
    },
    kW: {
      title: 'kW'
    },
    MW: {
      title: 'MW'
    },
    GW: {
      title: 'GW'
    }
  },
  PredictionErrorCode: {
    WEATHER_DATA_NOT_AVAILABLE: {
      title: 'Dáta o počasí sú nedostupné a boli použité interpolované hodnoty'
    },
    LOW_RELIABILITY_INCOMPLETE_INPUT_DATA_INTERPOLATING: {
      title:
        'Nekompletné vstupné dáta - chýbajúca hodnota bola doplnená interpoláciou'
    },
    LOW_RELIABILITY_INCOMPLETE_INPUT_DATA_FILL_WITH_CONSTANT: {
      title:
        'Nekompletné vstupné dáta a neúspešná interpolácia - chýbajúca hodnota bola doplnená konštantou'
    },
    LOW_RELIABILITY_OPTIMIZATION_UNFINISHED: {
      title:
        'Optimalizácia nenašla optimálne riešenie. Bolo navrhnuté riešenie, ktoré nemusí byť optimálne'
    },
    LOW_RELIABILITY_OTHER: {
      title: 'Nízka spoľahlivosť navrhovanej optimalizácie z iných dôvodov'
    },
    NOK: { title: 'Nastala neočakávaná chyba' },
    OK: { title: 'OK' },
    NOK_OPTIMIZATION_INFEASIBLE: {
      title:
        'Optimalizačný softvér nedokázal vrátiť akékoľvek riešenie optimalizačnej úlohy'
    },
    MISSING_CRITICAL_INPUT_DATA_EXCLUDING_DEVICE: {
      title:
        'Kritické dáta boli nedostupné, vynecháva sa dané zariadenie pred ďalším spracovaním optimalizácie'
    },
    MISSING_CRITICAL_INPUT_DATA_OPTIMIZATION_FAILED: {
      title: 'Pre dátový bod nebol poskytnutý výsledok z dôvodu chyby'
    },
    UNSUPPORTED_TOPOLOGY_OF_BALANCE_GROUP: {
      title: 'Nepodporovaná topológia bilančnej skupiny'
    }
  },
  EntsoeSystemImbalanceLoadingType: {
    intermediate: { title: 'prechodné' },
    final: { title: 'finálne' }
  },
  EntsoeWeatherEnergyType: {
    wind: { title: 'veterná energia' },
    solar: { title: 'solárna energia' }
  },
  OkteSystemImbalanceLoadingType: {
    preliminarydaily: { title: 'predbežné denné' },
    regulardaily: { title: 'pravidelné denné' }
  },
  OperationEvent: {
    str_PWD: { title: 'Strata napájacieho napätia' },
    por_charg: { title: 'Porucha dobíjania batérie' },
    por_bat: { title: 'Porucha batérie' },
    str_sig_U: { title: 'Strata signalizačného a ovládacieho napätia' },
    kom_elm_prah: { title: 'Porucha komunikácie s elektromerom na prahu OOM' },
    kom_elm_svorky: {
      title:
        'Porucha komunikácie s elektromerom svorkového merania zdroja/zariadenia'
    },
    ovl_miestne: { title: 'Miestne ovládanie OOM' },
    HRM_BLOK: { title: 'HRM blokovaný z dispečingu distribučnej spoločnosti' },
    por_ochr: { title: 'Porucha ochrany' },
    GP: { title: 'Pôsobenie ochrany' },
    FU_por: { title: 'Prepálená poistka' },
    por: { title: 'Porucha zariadenia' },
    kom_BESS: { title: 'Porucha komunikácie batériového úložiska' }
  },
  ReservedCapacityGuardingCheckResultStatus: {
    [ReservedCapacityGuardingCheckResultStatus.ACTIONS_NOT_NEEDED]: {
      title: 'Žiadne opatrenia nie sú potrebné'
    },
    [ReservedCapacityGuardingCheckResultStatus.ACTIONS_ISSUED]: {
      title: 'Boli vydané opatrenia'
    },
    [ReservedCapacityGuardingCheckResultStatus.ACTIONS_ISSUED_RESERVED_CAPACITY_EXCEEDED]:
      { title: 'Boli vydané opatrenia, avšak RK bude prekročená' },
    [ActivityLogEventCode.RESERVED_CAPACITY_EXCEEDED_NO_ACTIONS_POSSIBLE]: {
      title: 'Prekročená RK, nie sú možné žiadne akcie'
    }
  },
  ReservedCapacityGuardingActionType: {
    [ReservedCapacityGuardingActionTypeEnum.Increase]: {
      title: 'Navýšenie'
    },
    [ReservedCapacityGuardingActionTypeEnum.Reduction]: {
      title: 'Redukcia'
    }
  }
};

export default skSystemCodebooks;
